import * as types from '../mutation-types'

const state = {
  mediaUploadStatus: false,         // 文件上传状态
  config: {}, // 右侧组件的初始值 配置
  customConfig: {}, // property_data 右侧组件的基础组件初始值 配置
  renderComponentList: [], // 右侧需要渲染的配置组件列表
  pageData: {}, // 页面数据
  ruleComponentList: [], // 左边常规设置需要渲染的组件列表
}

const getters = {
  mediaUploadStatus: state => state.mediaUploadStatus,
}

const actions = {
}

const mutations = {
  [types.SET_MEDIA_UPLOAD_STATUS] (state, mediaUploadStatus) {
    state.mediaUploadStatus = mediaUploadStatus;
  },
  updateConfig (state, data) {
    state.config = data
  },
  updateCustomConfig (state, data) {
    state.customConfig = data
  },
  updateComponents (state, data) {
    state.renderComponentList = data
  },
  updatePageData (state, data) {
    state.pageData = data
  },
  updateRuleComponentList (state, data) {
    state.ruleComponentList = data
  },

}

export default {
  state,
  getters,
  actions,
  mutations
}
